import AlertsAll from 'common/alerts/containers/alert-all-container';
import DashboardContainer from 'common/dashboard/containers/dashboard-container';
import CreateOrders from 'order/create/containers/create-orders-container';
import PropTypes from 'prop-types';
import React from 'react';
import { isToggleEnabled } from 'react-awesome-feature-toggles';
import { Outlet, Route, Routes } from 'react-router-dom';

const InstalledAtDashboard = ({ id, renderMenu }) =>
  <>
    <DashboardContainer
      type='installedat'
      id={id}
      hasEquipments={true}
      hasFunctionalLocations={isToggleEnabled('showFunctionalLocationTable')}
      hasServices={true}
      hasShortTimeline={true}
      canCreateTicket={true}
      canCreateOrder={false}
      renderMenu={renderMenu}
    />
    <Routes>
      <Route path={'create-order/:type/:ids'} element={<CreateOrders />} />
      <Route path={'alerts'} element={<AlertsAll />} />
    </Routes>
    <Outlet />
  </>;
InstalledAtDashboard.propTypes = {
  id: PropTypes.string,
  renderMenu: PropTypes.func.isRequired,
};

export default InstalledAtDashboard;
